import React from 'react';
import PropTypes from 'prop-types';

const AppWebDevelopmentSkills = ({ type }) => {
  if (type === 'freelancer') {
    return (
      <>
        <li>
          <a href="/jobs/app-developers">App developer jobs</a>
        </li>
        <li>
          <a href="/jobs/developers">Developer jobs</a>
        </li>
        <li>
          <a href="/jobs/software-engineers">Software engineer jobs</a>
        </li>
        <li>
          <a href="/jobs/front-end-developers">Front-end developer jobs</a>
        </li>
        <li>
          <a href="/jobs/full-stack-developers">Full stack developer jobs</a>
        </li>
        <li>
          <a href="/jobs/back-end-developers">Back-end developer jobs</a>
        </li>
        <li>
          <a href="/jobs/data-engineers">Data engineer jobs</a>
        </li>
        <li>
          <a href="/jobs/ai-engineers">AI engineer jobs</a>
        </li>
        <li>
          <a href="/jobs/web-developers">Web developer jobs</a>
        </li>
        <li>
          <a href="/jobs/game-developers">Game developer jobs</a>
        </li>
        <li>
          <a href="/jobs/blockchain-developers">Blockchain developer jobs</a>
        </li>
        <li>
          <a href="/jobs/web-designers">Web designer jobs</a>
        </li>
      </>
    );
  }

  return (
    <>
      <li>
        <a href="/find/app-developers">App developers</a>
      </li>
      <li>
        <a href="/find/developers">Developers</a>
      </li>
      <li>
        <a href="/find/software-engineers">Software engineers</a>
      </li>
      <li>
        <a href="/find/front-end-developers">Front-end developers</a>
      </li>
      <li>
        <a href="/find/full-stack-developers">Full stack developers</a>
      </li>
      <li>
        <a href="/find/back-end-developers">Back-end developers</a>
      </li>
      <li>
        <a href="/find/data-engineers">Data engineers</a>
      </li>
      <li>
        <a href="/find/ai-engineers">AI engineers</a>
      </li>
      <li>
        <a href="/find/web-developers">Web developers</a>
      </li>
      <li>
        <a href="/find/game-developers">Game developers</a>
      </li>
      <li>
        <a href="/find/blockchain-developers">Blockchain developers</a>
      </li>
    </>
  );
};

AppWebDevelopmentSkills.propTypes = {
  type: PropTypes.string.isRequired,
};

export default AppWebDevelopmentSkills;
